import Vue from "vue";
import { Component, Prop } from "vuety";
import { IProductGroupItem, IProductGroupOptions } from "../../interfaces";
import { ListItem } from "./listItem";

const templateElement = "v-tmpl-grouplistlist";

@Component({
	template: document.getElementById(templateElement) ? "#" + templateElement : require("./listList.html"),
	components: { "list-item": ListItem },
	name: "list-list",
})
export class ListList extends Vue {
	@Prop() public groups: IProductGroupItem[];
	@Prop() public options: IProductGroupOptions;
	@Prop() public parentGroupCode: string;
}



// WEBPACK FOOTER //
// ./src/views/list/listList.ts